import React, { Component } from 'react';

import Loading from '../../Loading';
import ModalConfirm from '../../ModalConfirm';
import Alert from 'react-s-alert';
import ItemAgendamento from './ItemAgendamento';

class SimuladoAgendamento extends Component {

    alunosChecked = null

    constructor(props) {
        super(props)

        this.state = {
            showModalConfirmarExcluir: false,
            idEventPracticeTest: 0,
            idEvent: 0,
            loadingExcluir: false,
            students: {}
        };
        this.getPopoverAlunosDaTurma = this.getPopoverAlunosDaTurma.bind(this);
        this.getAlunosDoAgendamento = this.getAlunosDoAgendamento.bind(this);

        this.onClickConfirmarExcluir = this.onClickConfirmarExcluir.bind(this);
        this.onClickFecharModalExcluir = this.onClickFecharModalExcluir.bind(this);
        this.onReagendar = this.onReagendar.bind(this)
        this.onAgendar = this.onAgendar.bind(this)
        this.onExcluir = this.onExcluir.bind(this);


        //   this.onEditarAgendamentoAlunos = this.onEditarAgendamentoAlunos.bind(this);
        //    this.onExcluirAluno = this.onExcluirAluno.bind(this);

        this.canDelete = !!this.props.onDelete
    }
    // onEditarAgendamentoAlunos(alunos) {

    //     this.alunosChecked = alunos
    //     console.log('alunos ', this.alunosChecked)

    // }

    async onClickConfirmarExcluir() {
        this.setState({ loadingExcluir: true });
        var response = await this.props.onDelete(this.state.idEventPracticeTest, this.state.idEvent);
        if (response === true) {
            if (this.props.onUpdated) await this.props.onUpdated()
        } else {
            Alert.error(response)
        }
        this.setState({ loadingExcluir: false, showModalConfirmarExcluir: false });
    }

    onClickFecharModalExcluir() {
        this.setState({ showModalConfirmarExcluir: false });
    }


    async getPopoverAlunosDaTurma(idevent, identityclass) {
        try {
            //   console.log('popover')
            let students = await this.props.getStudents(idevent, identityclass);
            let msg = null;
            if (!Array.isArray(students)) {
                msg = students
            }
            var result = (
                <div className="edb-line-height-medium" style={{ width: '216px' }}>
                    {msg && <strong>{msg}</strong>}
                    {!msg && students && <span><strong>Alunos</strong><br />{students.map((item, index) => (<div key={`pop-turma-aluno-${idevent}-${identityclass}-${item.idUser}`}>•&nbsp;&nbsp;{item.txScreenName}</div>))}</span>}
                </div>
            );
            return result;
        }
        catch (e) {
            return 'Erro ao carregar alunos';
        }
    }

    async getAlunosDoAgendamento(idevent, identityclass) {
        try {
            //console.log('getAlunosDoAgendamento ')
            let students_list = await this.props.getStudents(idevent, identityclass);
            if(students_list) {
                let students = this.state.students;
                students[`event-${idevent}`] = students_list;
                this.setState({students: students});
            }
            // console.log(students)
            return students_list || [];
        }
        catch (e) {
            return 'Erro ao carregar alunos';
        }
    }

    async onReagendar(idEventPracticeTest, idEvent) {
        await this.props.practiceTestContainer.setState({ idEvent: idEvent })

        if (this.props.onClickAgendar) this.props.onClickAgendar(idEventPracticeTest, idEvent, 'reagendar', this.props.tipoSimulado, this.props.periodoSimulado, this.props.periodoSerie);
    }

    async onAgendar(idEventPracticeTest, idEvent, action) {


        await this.props.practiceTestContainer.setState({ idEvent: idEvent })

        if (this.props.onClickAgendar) this.props.onClickAgendar(idEventPracticeTest, idEvent, action, this.props.tipoSimulado, this.props.periodoSimulado, this.props.periodoSerie);
    }



    onExcluir(idEventPracticeTest, idEvent) {
        // console.log('this.props',this.props);
        let current = this.props.dados.find(f => f.idEventPracticeTest === idEventPracticeTest && f.idEvent === idEvent);
        if(current.EventToClass) {
            let agenda = this.props.dados.filter(f => f.idEventPracticeTest !== idEventPracticeTest && f.idEvent !== idEvent).map(m => {
                let n_mais = m.nuPracticeTestTotal>1?` e +${m.nuPracticeTestTotal-1}`:'';
                return `- <strong>${m.dtStartEvent}</strong> a <strong>${m.dtEndEvent}</strong> (${this.state.students[`event-${m.idEvent}`][0].txScreenName}${n_mais})`
            });

            if(agenda.length>0) {
                let s_plural = agenda.length>1?'s':'';
                Alert.warning(`Não é possível excluir o agendamento para esta turma. É necessário antes, excluir o${s_plural} outro${s_plural} agendamento${s_plural} dependente${s_plural} dele:<br />${agenda.join('<br />')}`, {html: true});
            }
            else {
                this.setState({ showModalConfirmarExcluir: true, idEventPracticeTest: idEventPracticeTest, idEvent: idEvent })
            }
        }
        else {
            this.setState({ showModalConfirmarExcluir: true, idEventPracticeTest: idEventPracticeTest, idEvent: idEvent })
        }
    }

    getDados() {
        return this.props.dados || [];
    }
    render() {

        return (<div className={" " + this.props.className}>
            <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                <thead className="edb-hide-small">
                    <tr>
                        <th width="264">
                            <div className="edb-cell-row">
                                <div className="edb-cell">
                                    <i className="far fa-calendar-alt edb-margin-small-right"></i>
                                </div>
                                <div className="edb-cell">
                                    Período de realização
                                </div>
                            </div>
                        </th>
                        <th width="140"><i className="far fa-chart-bar edb-margin-small-right"></i> Realizados</th>
                        <th><i className="fas fa-users edb-margin-small-right"></i> Turmas</th>
                        {!this.props.isProfessor && <th width="140"><i className="far fa-clock edb-margin-small-right"></i> Agenda</th>}
                    </tr>
                </thead>

                <tbody>
                    {this.props.loadingTabela && <tr><td colSpan="4"><Loading /></td></tr>}
                    {!this.props.loadingTabela && this.getDados().map(
                        (item, index) =>

                        <ItemAgendamento
                            key={`agendamento_${item.idEventPracticeTest}_${index}`}
                            item={item}
                            isProfessor={this.props.isProfessor}
                            onAgendar={this.onAgendar}
                            onReagendar={this.onReagendar}
                            onExcluir={this.onExcluir}
                            onDelete={this.canDelete}
                            getPopoverAlunosDaTurma={this.getPopoverAlunosDaTurma}
                            getAlunosDoAgendamento={this.getAlunosDoAgendamento}

                            />
                    )}
                    {/* Vazio */}
                    {!this.props.isProfessor && <tr>
                        <td className="edb-hide-small">-</td>
                        <td className="edb-hide-small">-</td>
                        <td className="edb-hide-small">-</td>
                        {this.props.classAvailable === 1 && <td className="edb-center"><div className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onAgendar(0, 0, 'agendar')}>Agendar</div></td>}
                        {this.props.classAvailable === 0 && <td className="edb-center"><div className="adap-text-black">Todas turmas agendadas</div></td>}
                    </tr>}

                </tbody>


            </table>
            {this.state.showModalConfirmarExcluir && <ModalConfirm isOpen={this.state.showModalConfirmarExcluir}
                title="Confirma excluir o agendamento?"

                confirmText="Sim"
                confirmLoadingText="Excluindo, por favor aguarde..."
                onClickConfirm={this.onClickConfirmarExcluir}
                loadingConfirm={this.state.loadingExcluir}

                cancelText="Não"
                onClickCancel={this.onClickFecharModalExcluir}
            />}
        </div>
        );
    }
}

// higher order component
export default SimuladoAgendamento;